import i18n from '@/plugins/i18n'

const paymentsStore = {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    getters: {
    },
    actions: {
		showBizumDirectConfirmDialog ({ commit, dispatch }, payload) {
			dispatch('showSharedDialog', {
                content: i18n.t('bizumDirectDialog', { phone: payload.phone }),
                okFn: payload.okFn,
                okBtnText: i18n.t('confirm')
            }, { root: true })
		}
	}
}

export default paymentsStore


// WEBPACK FOOTER //
// ./src/store/modules/payments.js